export const urlToFile = async (url, fileName, mimeType) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    // Create a File object from the blob
    const file = new File([blob], fileName, { type: mimeType });
    return file;
  } catch (error) {
    console.error("Error converting URL to file:", error);
  }
};
